import { useContext } from "react";
import { EntitlementsContext } from "@/contexts/EntitlementsContext";

/** Portfolio-wide capabilities — what the sidebar and route guards gate on. */
export function useEntitlements() {
  return useContext(EntitlementsContext);
}
